// Vuex users module mutations types
export const FILL_LIST = 'FILL_LIST';
export const FILL_LIST_EMPTY_CLIENTS = 'FILL_LIST_EMPTY_CLIENTS';
export const SET_FILTERING_CRITERIA = 'SET_FILTERING_CRITERIA';
export const SET_PAGE = 'SET_PAGE';
export const SET_RECORDS_PER_PAGE = 'SET_RECORDS_PER_PAGE';
